import { Component, OnInit } from '@angular/core';
import { DefaultLanguageCode, paths, language as languageModel } from '@app/constants';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Store } from '@ngrx/store';
import { State } from '@app/core/features';
import { selectors as userSelector } from '@app/core/features/auth/auth.selectors';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  isShowVoucherFooter: boolean;
  year = 0;

  constructor(
    private router: Router,
    private cookieService: CookieService,
    protected store: Store<State>
  ) {
    router.events.subscribe(() => {
      this.isShowVoucherFooter = this.checkShowVoucherFooter();
    });
  }

  ngOnInit() {
    this.isShowVoucherFooter = this.checkShowVoucherFooter();
    this.year = new Date().getFullYear();
  }

  checkShowVoucherFooter() {
    return this.router.url.substr(1).startsWith(paths.CHARTS_MANAGER);
  }

  getTermsOfUsePolicyLink() {
    let languageCode = this.cookieService.get('lang');
    if (!languageCode) {
      this.store
        .pipe(userSelector.getUserData)
        .pipe(take(1))
        .subscribe(
          (userData) => {
            if (userData) {
              languageCode = userData.language ?? DefaultLanguageCode;
            }
          }
        );
    }

    let languageInfo = languageModel.find(x => x.code === languageCode);
    return languageInfo.termsOfUsePolicyUrl;
  }
}
